import type { SdkQuizQuestionAnswerModel } from '../question-answer-model';
import type { SdkQuizQuestionModel } from '../question-model';
import { SdkGameEvent } from '@/src/sdk/events/gameEvent';

export class SdkQuizQuestionAnswerEvent extends SdkGameEvent {
  #promises: Promise<void>[] = [];

  constructor(
    public readonly question: SdkQuizQuestionModel,
    public readonly answers: SdkQuizQuestionAnswerModel[],
    public readonly correct: boolean
  ) {
    super();
  }

  public suspense(fn: () => Promise<void>) {
    this.#promises.push(fn());
  }

  public async waitForPromises() {
    await Promise.all(this.#promises);
  }

  public get hasSuspense(): boolean {
    return this.#promises.length > 0;
  }
}
